<script lang="ts">
  let { size = 18 }: { size?: number } = $props();
</script>

<svg class="spin" width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-opacity="0.2" stroke-width="3" />
  <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
</svg>

<style>
  .spin { animation: rot 0.7s linear infinite; }
  @keyframes rot { to { transform: rotate(360deg); } }
</style>
